import { createPluginFactory, onKeyDownToggleElement } from '@udecode/plate';

export const ELEMENT_CALLOUT_TIP = 'callout_tip';

export const createCalloutTipPlugin = createPluginFactory({
  key: ELEMENT_CALLOUT_TIP,
  isElement: true,
  deserializeHtml: { rules: [{ validNodeName: 'CALLOUT_TIP' }] },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: 'mod+shift+1',
  },
});
